<script setup>
import { inject } from 'vue'

const props = defineProps({
  title: { type: String },
  isUrl: { type: Boolean },
  disableSecondSlot: { type: Boolean },
  page: { type: String },
  blurred: { type: Boolean },
  zIndex: { type: String, default: '5' }
})
const { screen, global, isLoggedIn, application } = inject('Shared')
</script>

<template lang='pug'>
.row.quickViewFieldContainer
  template(v-if="!isUrl || screen.gt.xs")
    .titleContainer(
      :style="blurred ? `z-index: ${zIndex}` : undefined"
      :class="page === 'B2CAnalyzer' ? 'col-6' : 'col-lg-6 col-md-6 col-sm-6 col-xs-12'"
    )
      .row
        .row.relative-position
          .propTitle {{title}}
          .titleExtraContainer
          slot(name="titleExtra" :style="`color: ${global.graphicElementColor} !important`")
    div(
      :style="`color: ${global.graphicElementColor} !important`"
      :class="page === 'B2CAnalyzer' ? 'col-6' : 'col-lg-6 col-md-6 col-sm-6 col-xs-12 flex items-center'"
    )
      slot
  template(v-else)
    .row
      .relative-position.row
        .propTitle {{title}}
        .titleExtraContainer
          slot(name="titleExtra" :style="`color: ${global.graphicElementColor} !important`")
      slot(:style="`color: ${global.graphicElementColor} !important`")
</template>

<style scoped lang='sass'>
.quickViewFieldContainer
  @media screen and (min-width: 600px)
    padding-top: 7px
  @media screen and (max-width: 599px)
    margin-bottom: 10px
  .titleContainer
    .titleExtraContainer
      position: fixed
      right: 0px
      z-index: 3
    .propTitle
      color: #626C85
      font-size: 16px
      font-style: normal
      font-weight: 600
      letter-spacing: 0px
      text-align: left
      line-height: 200%
      margin-right: 6px
</style>
